import React from 'react'
import { useIntl } from 'react-intl'

import { useRecoilValue } from 'recoil'
import { pecPlusConfigState } from '../recoil/state/page'

import {
  MessageBox,
  MESSAGE_BOX_VARIANT_DANGER,
  Link,
  SpacingVertical,
  SPACING_16
} from 'mailup-web-components'
import { notifyParent } from 'Helpers/notifyParent'
import { PECPLUS_STATUS_ERROR_DESCR, STORE_KEY_ID_LIST } from 'Constants/index'
import { storeGet } from 'mailup-react-helpers'

const PecPlusError = () => {
  const intl = useIntl()
  const idList = storeGet(STORE_KEY_ID_LIST)
  const { statusListPecPlus, listName } = useRecoilValue(pecPlusConfigState)

  const handleListClick = idList =>
    notifyParent('setCurrentList', [
      idList,
      'form_upd_nl.aspx?visualmode=1&tab=mittenti',
      true
    ])

  return statusListPecPlus === PECPLUS_STATUS_ERROR_DESCR ? (
    <>
      <MessageBox
        variant={MESSAGE_BOX_VARIANT_DANGER}
        data-mu-test='c-pecplus-error-message'
      >
        <p>
          {intl.formatMessage(
            { id: 'Load.Schedulation.PecPlusListsConfigErrorIntl' },
            { linebreak: <br /> }
          )}
        </p>

        <Link onClick={() => handleListClick(idList)}>
          {idList} - {listName}
        </Link>
      </MessageBox>
      <SpacingVertical variant={SPACING_16} />
    </>
  ) : null
}

export default PecPlusError
